<script>
import iconSrc from './icons/ai-tutor-icon.svg'

export default {
    data() {
        return {
            iconSrc,

            // position
            x: 0,
            y: 0,

            // dragging state
            dragging: false,
            startX: 0,
            startY: 0,
            pointerStartX: 0,
            pointerStartY: 0,

            isMoved: false,

            // constants
            size: 80,
            padding: 24,
            moveThreshold: 2
        }
    },
    created() {
        this.initPosition()
    },
    mounted() {
        window.addEventListener('resize', this.snapToEdge)
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.snapToEdge)
        this.removeListeners()
    },

    methods: {
        /* ---------------- INIT ---------------- */
        initPosition() {
            this.x = window.innerWidth - this.size - this.padding
            this.y = window.innerHeight - this.size - this.padding
        },

        /* ---------------- POINTER ---------------- */
        onPointerDown(e) {
            const p = e.touches ? e.touches[0] : e

            this.dragging = true
            this.isMoved = false

            this.pointerStartX = p.clientX
            this.pointerStartY = p.clientY
            this.startX = this.x
            this.startY = this.y

            document.addEventListener('mousemove', this.onPointerMove)
            document.addEventListener('mouseup', this.onPointerUp)
            document.addEventListener('touchmove', this.onPointerMove, { passive: false })
            document.addEventListener('touchend', this.onPointerUp)
        },

        onPointerMove(e) {
            if (!this.dragging) return

            const p = e.touches ? e.touches[0] : e

            const dx = p.clientX - this.pointerStartX
            const dy = p.clientY - this.pointerStartY

            if (
                Math.abs(dx) > this.moveThreshold ||
                Math.abs(dy) > this.moveThreshold
            ) {
                this.isMoved = true
            }

            this.x = this.startX + dx
            this.y = this.startY + dy
        },

        onPointerUp() {
            if (!this.dragging) return

            this.dragging = false
            this.snapToEdge()
            this.removeListeners()
        },

        removeListeners() {
            document.removeEventListener('mousemove', this.onPointerMove)
            document.removeEventListener('mouseup', this.onPointerUp)
            document.removeEventListener('touchmove', this.onPointerMove)
            document.removeEventListener('touchend', this.onPointerUp)
        },

        /* ---------------- POSITION LOGIC ---------------- */
        snapToEdge() {
            const maxX = window.innerWidth - this.size - this.padding
            const maxY = window.innerHeight - this.size - this.padding

            // snap left / right
            this.x =
                this.x < window.innerWidth / 2
                    ? this.padding
                    : maxX

            // clamp Y
            this.y = Math.min(Math.max(this.padding, this.y), maxY)
        },

        /* ---------------- CLICK ---------------- */
        handleClick() {
            if (this.isMoved) return
            this.$emit('open')
        }
    }
}
</script>

<template>
    <div class="ai-tutor-close-button" :style="{
        transform: `translate3d(${x}px, ${y}px, 0)`
    }" :class="{ 'no-transition': dragging }" @mousedown.prevent="onPointerDown" @touchstart.prevent="onPointerDown"
        @click="handleClick">
        <img :src="iconSrc" class="ai-tutor-icon" draggable="false" />
    </div>
</template>

<style scoped>
.ai-tutor-close-button {
    position: fixed;
    top: 0;
    left: 0;
    background: linear-gradient(180deg, #65CBFD 0%, #1BA5FC 100%);
    border-radius: 100%;
    width: 5rem;
    height: 5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0.25rem 0.25rem 0px #0000001A;
    cursor: pointer;
    user-select: none;
    z-index: 99999;
    transition: transform 0.3s ease;
}

.no-transition {
    transition: none !important;
}

.ai-tutor-icon {
    width: 3rem;
    height: auto;
    pointer-events: none;
}
</style>
